module.exports = __webpack_public_path__ + "img/output-12.0f095425.png";